export default __webpack_public_path__ + "static/media/Token-suite.43db87fc.png";